import { articles } from '@/lib/articles';
export interface BlogPost {
  slug: string;
  title: string;
  date: string;
  dateModified: string;
  description: string;
  image?: string;
  readTime?: string;
  content?: string;
}

const matchArticleBySlug = function(title){
  return articles.find((a) => {
      return a.id === title
  })

}
const rawModules = import.meta.glob('/src/blog/**/*.md', {
  query: '?raw',
  import: 'default',
  eager: false,
});

export async function getAllPosts(): Promise<BlogPost[]> {
  const posts: BlogPost[] = [];

  for (const [path] of Object.entries(rawModules)) {
    const slug = path.replace('/src/blog/', '').replace('.md', '');
    const article = matchArticleBySlug(slug)
    if(!article){
      console.log(slug)
    }

    posts.push({
      slug,
      title: article?.title || '',
      date: article?.date || '',
      dateModified: article?.dateModified || article?.date || '',
      description: article?.desc || '',
      image: article?.img || '',
      readTime: article?.readTime || '',
    });
  }

  posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  return posts;
}

export async function getPostBySlug(slug: string): Promise<BlogPost | null> {
  const path = `/src/blog/${slug}.md`;

  const loader = rawModules[path];

  if (!loader) return null;

  const raw = await loader();

  const content = raw as string;

  const article = matchArticleBySlug(slug)

  return {
    slug,
    title: article.title || '',
    date: article.date || '',
    dateModified: article.dateModified || article.date || '',
    description: article.desc || '',
    image: article.img || '',
    readTime: article.readTime || '',
    content,
  };
}
